




































import Vue from 'vue'
import ResultTable from '@/components/spiders/results/result-table.vue'
import { RunRepository, ResultRepository } from '@/core/api/results'
import VueJsonPretty from 'vue-json-pretty'

export default Vue.extend({
  components: {
    ResultTable,
    VueJsonPretty,
  },
  props: {
    runId: {
      type: String,
      default: null,
    },
  },
  data: () => ({
    run: null as any,
    loading: false,
    items: [],
    itemsCount: null,
    itemsPage: 1,
    itemsPages: 1,
    autoRefreshInterval: null as any,
    autoRefreshDelay: 5000,
  }),
  watch: {
    runId() {
      this.run = null
      this.itemsPage = 1
      this.fetch()
    },
  },
  mounted() {
    this.fetch()
    this.autoRefreshInterval = setInterval(() => {
      this.fetch()
    }, this.autoRefreshDelay)
  },
  beforeDestroy() {
    clearInterval(this.autoRefreshInterval)
  },
  methods: {
    async fetch() {
      if (this.runId == null) {
        return
      }

      this.loading = true
      try {
        this.run = await new RunRepository().$get(this.runId)
        const data = await new ResultRepository(this.runId).$getPage(this.itemsPage)

        this.items = data.results
        this.itemsPages = data.pages
        this.itemsCount = data.count
      } catch (err) {
        this.$toastError.fire()
      }
      this.loading = false
    },
    onPageChange(page) {
      this.itemsPage = page
      this.fetch()
    },
  },
})
